import { render } from "./MasterLayout.vue?vue&type=template&id=49e84348"
import script from "./MasterLayout.vue?vue&type=script&lang=js"
export * from "./MasterLayout.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MasterLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49e84348"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49e84348', __exports__)) {
    api.reload('49e84348', __exports__)
  }
  
  module.hot.accept("./MasterLayout.vue?vue&type=template&id=49e84348", () => {
    api.rerender('49e84348', render)
  })

}


export default __exports__